namespace TabAurous.ProductDevelopment {
    export interface PDInterfaceForm {
        CustomerRequirements: CustomerRequirementItemsEditorForPD;
        Designing: DesigningItemsEditorForPD;
        SpecSheets: SpecSheetEditorForPD;
        Quotations: QuotationItemsEditorForPD;
    }

    export class PDInterfaceForm extends Serenity.PrefixedContext {
        static formKey = 'ProductDevelopment.PDInterface';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PDInterfaceForm.init)  {
                PDInterfaceForm.init = true;

                var s = Serenity;
                var w0 = CustomerRequirementItemsEditorForPD;
                var w1 = DesigningItemsEditorForPD;
                var w2 = SpecSheetEditorForPD;
                var w3 = QuotationItemsEditorForPD;

                Q.initFormType(PDInterfaceForm, [
                    'CustomerRequirements', w0,
                    'Designing', w1,
                    'SpecSheets', w2,
                    'Quotations', w3
                ]);
            }
        }
    }
}
